import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Checkbox,
  Typography,
  Box,
  Stack,
  Avatar,
  AvatarGroup,
  Popover,
  IconButton,
  Modal,
  Button,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IosShareIcon from "@mui/icons-material/IosShare";
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import moreicon from "../../assets/landing_page/new/morehorizontal.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setPlanForDelete,
  setPlanForEdit,
  setPlanForShare,
  setPlanForView,
} from "../../Slices/planslice";
import my_plan from "../../assets/landing_page/new/my_plan.png";
import shared from "../../assets/landing_page/new/Shared Plan.svg";
function CardShare({ planData = [] }) {
  const ProjectCard = ({ id, title, user_id, createdBy, email_address, avatars, extraCount }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const userId = localStorage.getItem("user_id")
    const handleActionOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseAction = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const ids = open ? "user-options-popover" : undefined;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleEdit = () => {
      dispatch(setPlanForEdit({ id, isEdit: true, table: false }));
      navigate("/home/createplan");
      handleCloseAction();
    };
    const handleDelete = () => {
      dispatch(
        setPlanForDelete({
          id,
          isDelete: true,
          table: false,
        })
      );
      navigate("/home/createplan");
      handleCloseAction();
    };
    const handleView = () => {
      dispatch(setPlanForView({ id, isView: true, table: false }));
      navigate("/home/viewplan");
      handleCloseAction();
    };
    const handleShare = () => {
      dispatch(setPlanForShare({ id, isShare: true, table: false }));
      navigate("/home/plan-share-screen");
      handleCloseAction();
    };

    const username = localStorage.getItem("user_name");
    return (
      <>
        <Card
          variant='outlined'
          sx={{
            width: 230,
            borderRadius: 2,
            margin: "10px", // Added margin to space the cards
          }}>
          <CardHeader
            title={
              <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'>
                <Typography
                  variant='h6'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "13px",
                    fontWeight: 600,
                    lineHeight: "14.52px",
                    textAlign: "left",
                    marginRight: "20px",
                    marginBottom: "10px",
                  }}>
                  {title}
                </Typography>
                <AvatarGroup
                  max={2}
                  sx={{ marginLeft: "auto", marginBottom: "10px" }}>
                  {avatars.map((avatar, index) => (
                    <Avatar
                      key={index}
                      alt={`Avatar ${index + 1}`}
                      src={avatar}
                      sx={{ width: 20, height: 20 }}
                    />
                  ))}
                  {extraCount > 0 && (
                    <Avatar sx={{ width: 20, height: 20 }}>
                      +{extraCount}
                    </Avatar>
                  )}
                </AvatarGroup>
              </Stack>
            }
            sx={{ pb: 0, backgroundColor: "#E5EEFB66" }}
          />

          <CardContent sx={{ px: 1, py: 0 }}>
            <Box
              sx={{
                position: "relative", // To ensure Button is positioned relative to this Box
                width: "100%",
                height: 80,
                "&:hover": {
                  color: "#0000001A", // Background color change on hover
                },
              }}>
              <CardMedia
                component='img'
                image={cardbackground}
                alt='Project Timeline'
                sx={{
                  height: "100%", // Keep the height full for the container
                  width: "100%", // Make sure the image fills the Box
                  borderRadius: 1,
                  objectFit: "cover",
                  backgroundColor: "#0000001A",
                  transition: "background-color 0.3s ease",
                }}
              />
              <CardMedia
                component='img'
                image={my_plan} // Import path for your image
                alt={"My Plan"}
                sx={{
                  position: "absolute",
                  top: 0, // Adjust as needed
                  right: 0, // Adjust as needed
                  width: 100, // Image size
                  height: 24, // Image size
                  //borderRadius: "50%", // If you want it to be circular, you can remove this if not needed
                }}
              />
              <Button
                variant='contained'
                onClick={handleShare}
                sx={{
                  display: "block", // Show on hover
                  position: "absolute",
                  top: "50%", // Center vertically
                  left: "50%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjust position to be exactly in the center
                  backgroundColor: "transparent",
                  color: "#000",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  //zIndex: 1,
                  boxShadow: "none",
                  textTransform: "none",
                  border: "1px solid #474747",
                  "&:hover": {
                    backgroundColor: "transparent",
                    border: "1px solid #474747",
                    color: "#000",
                    boxShadow: "none",
                  },
                }}>
                Share Plan
              </Button>
            </Box>

            <Box
              sx={{
                borderBottom: "1px solid #ccc",
                backgroundColor: "#E5EEFB66",
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "transparent",
              }}>
              <Box>
                <Typography
                  variant='body1'
                  color='textSecondary'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    textAlign: "left",
                    marginTop: "5px",
                  }}>
                  Created by
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    textAlign: "left",
                  }}>
                  {email_address}
                </Typography>
              </Box>
              <IconButton aria-label='settings' onClick={handleActionOpen}>
                <img
                  src={moreicon}
                  alt='More options'
                  style={{ width: "20px", height: "20px" }}
                />
              </IconButton>
            </Box>
          </CardContent>
        </Card>

        <Popover
          id={ids}
          open={open}
          anchorEl={anchorEl}
          onClose={handleCloseAction}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}>
          <Box sx={{ p: 1, width: "130px" }}>
            <Button
              onClick={handleView}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none", // to keep the text lowercase

                color: "black", // you can adjust color as needed
              }}>
              <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography
                id='view-user'
                variant='body1'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "14.52px",
                }}>
                View Plan
              </Typography>
            </Button>
            <Button
              onClick={handleEdit}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",

                color: "black",
              }}>
              <EditIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography
                id='edit-user'
                variant='body1'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "14.52px",
                }}>
                Edit Plan
              </Typography>
            </Button>
            <Button
              onClick={handleShare}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",

                color: "black",
              }}>
              <IosShareIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography
                id='edit-user'
                variant='body1'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "14.52px",
                  textAlign: "left",
                }}>
                Share Plan
              </Typography>
            </Button>
            <Button
              onClick={handleDelete}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",

                color: "black",
              }}>
              <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography
                id='delete-user'
                variant='body1'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "14.52px",
                }}>
                Delete Plan
              </Typography>
            </Button>
          </Box>
        </Popover>
      </>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0, // Adds spacing between items

          marginTop: "0px",
        }}>
        {planData.map((plan, index) => (
          <ProjectCard
            key={plan.id}
            id={plan.id}
            title={plan.plan_name}
            user_id={plan.user_id} // Taking title from planData
            createdBy={plan.created_by} // Assuming there's a createdBy field
            email_address={plan.users.email} // Assuming there's a createdBy field
            avatars={plan.avatars || []} // Default to an empty array if avatars is not provided
            extraCount={plan.extraCount || 0} // Default to 0 if extraCount is not provided
            sx={{
              flexBasis: "calc(25% - 20px)", // Each card will take up 25% of the row minus some margin
              margin: "10px", // Space around each card
            }}
          />
        ))}
      </Box>
    </>
  );
}

export default CardShare;
